import * as zoid from 'zoid/dist/zoid.frameworks.frame.min'

const ZoidGenerator = ({
    tag, url, containerStyle = null, frameStyle = null,
}) => zoid.create({
    tag,
    url,
    containerTemplate({
        doc, uid, frame, prerenderFrame, event,
    }) {
        const container = doc.createElement('div')

        container.id = uid

        if (containerStyle) {
            Object.assign(container.style, containerStyle)
        }

        if (frameStyle) {
            Object.assign(frame.style, frameStyle)
        }

        container.appendChild(frame)
        container.appendChild(prerenderFrame)

        event.on(zoid.EVENT.RENDERED, () => {
            prerenderFrame.remove()
        })

        return container
    },
    prerenderTemplate({ doc }) {
        const html = doc.createElement('html')
        const body = doc.createElement('body')

        html.appendChild(body)

        return html
    },
})

export default ZoidGenerator
